import { Col, Row } from 'antd';
import React, { FC } from 'react';
import COButton, { Props as ButtonProps } from 'shared/components/COButton';
import styles from './modalFooter.module.scss';
import clsx from 'clsx';

export interface ModalFooterProps {
  confirmButtonProps?: ButtonProps;
  cancelButtonProps: ButtonProps;
  wrapClassName?: string;
}

const ModalFooter: FC<ModalFooterProps> = ({
  cancelButtonProps,
  confirmButtonProps,
  wrapClassName,
}) => {
  return (
    <Row
      className={clsx(styles.footerWrapper, wrapClassName)}
      justify="center"
      align="middle">
      {confirmButtonProps?.children && (
        <Col>
          <COButton {...confirmButtonProps}>
            {confirmButtonProps?.children}
          </COButton>
        </Col>
      )}
      <Col>
        <COButton {...cancelButtonProps}>
          {cancelButtonProps?.children}
        </COButton>
      </Col>
    </Row>
  );
};

export default ModalFooter;
